<template>
  <template v-for="(value, index) in qrInfo" :key="index">
    <div class="wechatcover" v-show="value.visible">
      <div class="qrcode-popup">
        <p>{{ value.title }}</p>
        <div class="qrcode-placeholder">
          <img class="qrcode-img" :src="value.imageSrc" :alt="value.altText" />
        </div>
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
interface QrcodeType {
  visible: boolean;
  title: string;
  imageSrc: string;
  altText: string;
}
type QrcodePopupPropsType = {
  qrInfo: QrcodeType[];
};

defineProps<QrcodePopupPropsType>();
</script>

<style scoped>
.wechatcover {
  position: fixed;
  top: 80px;
  right: 20px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  max-width: calc(100vw - 40px);
}

.qrcode-popup {
  text-align: center;
}

.qrcode-popup p {
  margin: 0 0 10px 0;
  color: #333;
  font-weight: 500;
  font-size: 0.95rem;
}

.qrcode-placeholder {
  width: 150px;
  height: 150px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  border-radius: 5px;
}

.qrcode-img {
  width: 147px;
  height: 147px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .wechatcover {
    top: 70px;
    right: 10px;
    padding: 15px;
  }
  
  .qrcode-popup p {
    font-size: 0.9rem;
  }
  
  .qrcode-placeholder {
    width: 130px;
    height: 130px;
  }
  
  .qrcode-img {
    width: 127px;
    height: 127px;
  }
}

@media (max-width: 480px) {
  .wechatcover {
    top: 65px;
    right: 5px;
    padding: 12px;
  }
  
  .qrcode-popup p {
    font-size: 0.85rem;
    margin-bottom: 8px;
  }
  
  .qrcode-placeholder {
    width: 110px;
    height: 110px;
  }
  
  .qrcode-img {
    width: 107px;
    height: 107px;
  }
}
</style>
